import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { TRY_ON_PHOTOS_QUERY_KEY } from "@/api/hooks/use-try-on-photos";
import { queryService } from "@/api/services/query-service";
import useAuthStore from "@/store/use-auth-store";
import {
  computePersonaCompleteness,
  type PersonaCompleteness,
} from "../lib/completeness";

/**
 * Persona quest tamamlılığı — auth user + try-on listesi.
 * Settings form store'una dokunmaz (route guard'da yan etki olmasın).
 */
export const usePersonaCompleteness = (): PersonaCompleteness & {
  photoCount: number;
  isLoading: boolean;
} => {
  const user = useAuthStore((state) => state.user);
  const accessToken = useAuthStore((state) => state.accessToken);

  const photosQuery = useQuery({
    queryKey: TRY_ON_PHOTOS_QUERY_KEY,
    queryFn: () => queryService.getTryOnPhotos(),
    enabled: !!accessToken && !!user?._id,
    staleTime: 60 * 1000,
  });

  const photoCount = photosQuery.data?.data.photos.length ?? 0;

  const completeness = useMemo(
    () =>
      computePersonaCompleteness(
        {
          gender: user?.gender,
          age: user?.age,
          height: user?.height,
          size: user?.size,
          shoeSize: user?.shoeSize,
          region: user?.region,
          phoneNumber: user?.phoneNumber,
        },
        photoCount
      ),
    [
      user?.gender,
      user?.age,
      user?.height,
      user?.size,
      user?.shoeSize,
      user?.region,
      user?.phoneNumber,
      photoCount,
    ]
  );

  return {
    ...completeness,
    photoCount,
    isLoading: !!accessToken && photosQuery.isPending,
  };
};
